"use client";

import { Suspense } from "react";

import type { PlpModalProps } from "@/lib/centra/hooks/usePlp";
import FilterModal from "./Filter";

const PlpModals = ({
  filters: formattedFilters,
  productCount,
  currentAppliedFilters,
}: PlpModalProps) => {
  return (
    <>
      <Suspense fallback="...">
        <FilterModal
          currentAppliedFilters={currentAppliedFilters}
          filters={formattedFilters}
          productCount={productCount}
        />
      </Suspense>
    </>
  );
};

export default PlpModals;
